/* LaserTech — global.js */
(function () {
  'use strict';

  /* ---- Mobile navigation ---- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const navOverlay = document.querySelector('[data-nav-overlay]');
  const menuClose = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (navOverlay) navOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (navOverlay) navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (navOverlay) navOverlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* ---- Product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const src = thumb.getAttribute('data-src');
        if (mainImg && src) mainImg.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---- Product description "show more" ---- */
  document.querySelectorAll('[data-desc-wrap]').forEach(function (wrap) {
    var desc = wrap.querySelector('[data-desc]');
    var btn = wrap.querySelector('[data-desc-toggle]');
    if (!desc || !btn) return;
    var moreEl = btn.querySelector('[data-desc-more]');
    var lessEl = btn.querySelector('[data-desc-less]');
    desc.classList.add('is-clamped');
    function overflowing() { return desc.scrollHeight - 2 > desc.clientHeight; }
    if (overflowing()) {
      btn.hidden = false;
    } else {
      desc.classList.remove('is-clamped');
    }
    btn.addEventListener('click', function () {
      var clamped = desc.classList.toggle('is-clamped');
      btn.setAttribute('aria-expanded', String(!clamped));
      if (moreEl) moreEl.hidden = !clamped;
      if (lessEl) lessEl.hidden = clamped;
    });
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = parseInt(btn.getAttribute('data-qty-btn'), 10);
        let val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Variant selection ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    const dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const compareEl = form.querySelector('[data-price-compare]');
    const submitBtn = form.querySelector('[data-add-btn]');
    const moneyFormat = form.getAttribute('data-money-format') || '{{amount}}';

    function formatMoney(cents) {
      const value = (cents / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
    }

    function currentSelections() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]:checked'),
        function (i) { return i.value; }
      );
    }

    function update() {
      const sel = currentSelections();
      const match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? submitBtn.getAttribute('data-label-default') : submitBtn.getAttribute('data-label-soldout');
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  });

  /* ---- Info modals (on-page, no navigation) ---- */
  function closeInfoModals() {
    document.querySelectorAll('.info-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-info-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-info-open');
      var modal = document.querySelector('[data-info-modal="' + id + '"]');
      if (modal) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-info-close]').forEach(function (el) {
    el.addEventListener('click', closeInfoModals);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfoModals(); });

  /* ---- Newsletter (demo, no backend in preview) ---- */
  document.querySelectorAll('[data-newsletter-demo]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-live') === 'true') return;
      e.preventDefault();
      form.innerHTML = '<p style="color:var(--color-in-stock);margin:0;">Díky! Ozveme se, jakmile spustíme.</p>';
    });
  });
})();
